import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Price of the product page (`blocks/pc-pdp-price.liquid`).
 *
 * The server renders the price of the selected size. When the visitor picks another size, the variant picker fetches the
 * page for that variant; this component takes the new price from that response.
 *
 * @extends {Component}
 */
class PcPdpPrice extends Component {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    super.connectedCallback();

    this.#abort = new AbortController();
    const section = this.closest('.shopify-section, dialog');
    section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abort?.abort();
    this.#abort = undefined;
  }

  /**
   * Takes the price of the newly selected variant from the section response.
   * @param {Event} event
   */
  #onProductSelect = (event) => {
    const { promise } = /** @type {{ promise?: Promise<{ detail?: { html?: Document } }> }} */ (event);
    if (!promise) return;

    promise
      .then(({ detail }) => {
        const source = detail?.html?.querySelector(`pc-pdp-price[data-block-id="${this.dataset.blockId}"]`);
        if (source) this.replaceChildren(...source.childNodes);
      })
      .catch(() => {
        // Aborted or failed selection: keep the current price
      });
  };
}

if (!customElements.get('pc-pdp-price')) {
  customElements.define('pc-pdp-price', PcPdpPrice);
}
